import { createSelector } from 'reselect';
import { getThemeSettingsValues, getThemeFields, getThemePresetStyles } from 'ContentData/selectors/themeSettings';
import { getBrandSettings } from 'ContentData/selectors/branding';
export const getInheritanceData = createSelector([getThemeSettingsValues, getThemeFields, getBrandSettings, getThemePresetStyles], (themeSettings, themeFields, brandSettings, themePresetStyles) => ({
  brandSettings,
  themeFields,
  themeSettings,
  themePresetStyles
}));